import { CommonIcons, icons } from '../../components/common/CommonIcons';

const navConfig = [
  {
    title: 'dashboard',
    path: 'dashboard',
    icon: <CommonIcons name={icons.dashboard} />,
  },
  {
    title: 'people',
    icon: <CommonIcons name={icons.users} />,
    children: [
      {
        title: 'administrators',
        path: 'users/administrators',
        allowOpenNew: true,
      },
      {
        title: 'customers',
        path: 'users/customers',
        allowOpenNew: true,
      },
      {
        title: 'suppliers',
        path: 'users/suppliers',
        allowOpenNew: true,
      },
      {
        title: 'retailers',
        path: 'users/retailers',
        allowOpenNew: true,
      },
      {
        title: 'drivers',
        path: 'users/drivers',
        allowOpenNew: true,
      },
      {
        title: 'workers',
        path: 'users/workers',
        allowOpenNew: true,
      },
    ],
  },
  {
    title: 'products',
    icon: <CommonIcons name={icons.products} />,
    children: [
      {
        title: 'items',
        path: 'products/items',
        allowOpenNew: true,
      },
      {
        title: 'categories',
        path: 'products/categories',
        allowOpenNew: true,
      },
      {
        title: 'brands',
        path: 'products/brands',
        allowOpenNew: true,
      },
      {
        title: 'uoms',
        path: 'products/uoms',
        allowOpenNew: true,
      },
    ],
  },
  {
    title: 'sales',
    icon: <CommonIcons name={icons.sales} />,
    children: [
      {
        title: 'salesOrders',
        path: 'documents/salesOrders',
        allowOpenNew: true,
      },
      {
        title: 'perfomaSales',
        path: 'documents/perfomaSales',
        allowOpenNew: true,
      },
      {
        title: 'salesInvoices',
        path: 'documents/salesInvoices',
        allowOpenNew: true,
      },
      {
        title: 'cashSales',
        path: 'documents/cashSales',
        allowOpenNew: true,
      },
      {
        title: 'deliveryOrders',
        path: 'documents/deliveryOrders',
        allowOpenNew: true,
      },
      {
        title: 'salesDebitNotes',
        path: 'documents/salesDebitNotes',
        allowOpenNew: true,
      },
      {
        title: 'salesCreditNotes',
        path: 'documents/salesCreditNotes',
        allowOpenNew: true,
      },
      {
        title: 'replacementDeliveries',
        path: 'documents/replacementDeliveries',
        allowOpenNew: true,
      },
      {
        title: 'retailCashSales',
        path: 'documents/retailCashSales',
        allowOpenNew: true,
      },
    ],
  },
  {
    title: 'purchases',
    icon: <CommonIcons name={icons.purchase} />,
    children: [
      {
        title: 'purchaseOrders',
        path: 'documents/purchaseOrders',
        allowOpenNew: true,
      },
      {
        title: 'purchaseReturns',
        path: 'documents/purchaseReturns',
        allowOpenNew: true,
      },
      {
        title: 'purchaseInvoices',
        path: 'documents/purchaseInvoices',
        allowOpenNew: true,
      },
    ],
  },
  {
    title: 'warehouse',
    icon: <CommonIcons name={icons.warehouse} />,
    children: [
      {
        title: 'itemReceives',
        path: 'documents/itemReceives',
        allowOpenNew: true,
      },
      {
        title: 'itemTransfers',
        path: 'documents/itemTransfers',
        allowOpenNew: true,
      },
      {
        title: 'itemRelocates',
        path: 'documents/itemRelocates',
        allowOpenNew: true,
      },
      {
        title: 'itemTransforms',
        path: 'documents/itemTransform',
        allowOpenNew: true,
      },
      // {
      //   title: 'Packing Orders',
      //   path: 'documents/packingOrders'
      // },
      {
        title: 'itemIssues',
        path: 'documents/itemIssues',
        allowOpenNew: true,
      },
      {
        title: 'itemAdjustments',
        path: 'documents/itemAdjustments',
        allowOpenNew: true,
      },
      {
        title: 'stockTakes',
        path: 'documents/stockTakes',
        allowOpenNew: true,
      },
      {
        title: 'transferReturns',
        path: 'documents/transferReturns',
        allowOpenNew: true,
      },
      {
        title: 'transferRequisitions',
        path: 'documents/transferRequisitions',
        allowOpenNew: true,
      },
      {
        title: 'pickOrders',
        path: 'documents/pickOrders',
        allowOpenNew: true,
      },
    ],
  },
  {
    title: 'logistics',
    icon: <CommonIcons name={icons.logistic} />,
    children: [
      {
        title: 'transporters',
        path: 'logistics/transporters',
        allowOpenNew: true,
      },
      {
        title: 'deliveryTrips',
        path: 'documents/tripOrders',
        allowOpenNew: true,
      },
    ],
  },
  {
    title: 'others',
    icon: <CommonIcons name={icons.documents} />,
    children: [
      {
        title: 'retailPrescriptions',
        path: 'documents/retailPrescriptions',
        allowOpenNew: true,
      },
      {
        title: 'retailCashSales',
        path: 'documents/retailCashSales',
        allowOpenNew: true,
      },
    ],
  },
  {
    title: 'repositories',
    path: '',
    icon: <CommonIcons name={icons.repository} />,
    children: [
      {
        title: 'containers',
        path: 'repositories/containers',
        allowOpenNew: true,
      },
      {
        title: 'packages',
        path: 'repositories/packages',
        allowOpenNew: true,
      },
    ],
  },
  {
    title: 'operations',
    path: '',
    icon: <CommonIcons name={icons.operations} />,
    children: [
      {
        title: 'examineInventory',
        path: 'operations/inventory/examine',
        allowOpenNew: true,
      },
      {
        title: 'itemRelocateThreshold',
        path: 'operations/itemThreshold/relocate',
        allowOpenNew: true,
      },
      {
        title: 'itemReorderThreshold',
        path: 'operations/itemThreshold/reorder',
        allowOpenNew: true,
      },
    ],
  },
  {
    title: 'groups',
    path: '',
    icon: <CommonIcons name={icons.group} />,
    children: [
      {
        title: 'administrators',
        path: 'groups/administrators',
        allowOpenNew: true,
      },
      {
        title: 'customers',
        path: 'groups/customers',
        allowOpenNew: true,
      },
      {
        title: 'suppliers',
        path: 'groups/suppliers',
        allowOpenNew: true,
      },
    ],
  },
  {
    title: 'reports',
    path: '',
    icon: <CommonIcons name={icons.report} />,
    children: [
      {
        title: 'products',
        path: 'reports/product/productItem',
        allowOpenNew: true,
      },
      {
        title: 'sales',
        path: 'reports/sales/salesOrder',
        allowOpenNew: true,
      },
      {
        title: 'warehouse',
        path: 'reports/warehouse/itemReceive',
        allowOpenNew: true,
      },
      {
        title: 'inventories',
        path: 'reports/inventory/stockValue',
        allowOpenNew: true,
      },
    ],
  },
  // {
  //   title: 'schedulers',
  //   path: '',
  //   icon: <CommonIcons name={icons.schedule} />,
  //   children: [
  //     {
  //       title: 'tasks',
  //       path: 'scheduler/tasks',
  //       allowOpenNew: true,
  //     },
  //     {
  //       title: 'logs',
  //       path: 'scheduler/logs',
  //       allowOpenNew: true,
  //     },
  //     {
  //       title: 'requests',
  //       path: 'scheduler/requests',
  //       allowOpenNew: true,
  //     },
  //     {
  //       title: 'console',
  //       path: 'scheduler/console',
  //       allowOpenNew: true,
  //     },
  //   ]
  // },
  {
    title: 'transactions',
    path: '',
    icon: <CommonIcons name={icons.transaction} />,
    children: [
      {
        title: 'walletTransactions',
        path: 'transactions/walletTransactions',
        allowOpenNew: true,
      },
      {
        title: 'walletRequests',
        path: 'transactions/walletRequests',
        allowOpenNew: true,
      },
    ],
  },
  {
    title: 'settings',
    icon: <CommonIcons name={icons.setting} />,
    path: 'settings',
    // children: [
    //   {
    //     title: 'rolesAndPermissions',
    //     path: 'settings/userRoles',
    //     allowOpenNew: true,
    //   },
    //   {
    //     title: 'business',
    //     path: 'settings/business',
    //     allowOpenNew: true,
    //   },
    //   {
    //     title: 'locations',
    //     path: 'settings/locations',
    //     allowOpenNew: true,
    //   },
    //   {
    //     title: 'regions',
    //     path: 'settings/countries',
    //     allowOpenNew: true,
    //   },
    //   {
    //     title: 'customFields',
    //     path: 'customFields',
    //     allowOpenNew: true,
    //   },
    //   {
    //     title: 'shippingRates',
    //     path: 'settings/shippingRates',
    //     allowOpenNew: true,
    //   },
    //   {
    //     title: 'auditTrails',
    //     path: 'settings/auditTrails',
    //     allowOpenNew: true,
    //   },
    //   {
    //     title: 'injectionProps',
    //     path: 'injectionProps',
    //     allowOpenNew: true,
    //   },
    //   {
    //     title: 'taxRates',
    //     path: 'settings/taxRates',
    //     allowOpenNew: true,
    //   },
    //   {
    //     title: 'Setting',
    //     path: 'settings',
    //     allowOpenNew: true,
    //   },
    // ]
  },
];

export default navConfig;
